import { useGetStatusOfGenerationQuery } from "../../../redux/services/apiHome";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { replaceMonthWithHindi } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useMemo } from "react";

const StatusOfGeneration = ({ data }) => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: fetchedData = {}, isLoading } = useGetStatusOfGenerationQuery({
    query: data,
    lang: languageType,
  });

  const safeData =
    fetchedData && typeof fetchedData === "object" ? fetchedData : {};

  const fetchedDataArray = useMemo(() => {
    return Object.entries(safeData).map(([parentKey, parentValue]) => ({
      name: parentKey,
      ...parentValue,
      children: Object.entries(parentValue?.children || {}).map(
        ([childKey, childValue]) => ({
          name: childKey,
          ...childValue,
        }),
      ),
    }));
  }, [safeData]);

  const parent = fetchedDataArray[0] || {};
  const parentName = parent.name || "";
  const {
    description,
    generation_for_the_month,
    total_generation_during_financial_year,
    april_label,
    financial_year,
    total_generation_from_april,
    children = [],
  } = parent;

  const maybeTranslate = (text) => {
    if (!text) return "N/A";
    return languageType === "hi" ? replaceMonthWithHindi(text) : text;
  };
  const getTitle = (text) => {
    if (!text) return "N/A";
    return text.split("_").join(" ");
  };
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="title-sec">
        <h4>{getText("Status of Generation", "उत्पादन की स्थिति")}</h4>
      </div>
      {/* parent table */}
      <div className="table-responsive mb-3">
        {children.length > 0 && (
          <h3 className="title4">{getTitle(parentName)}</h3>
        )}

        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Generation (MU)", "उत्त्पादन (एमयू)")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-key="S.No">1</td>
              <td data-key="Description">{maybeTranslate(description)}</td>
              <td data-key="Generation (MU)">
                {generation_for_the_month}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
            <tr>
              <td data-key="S.No">2</td>
              <td data-key="Description">{maybeTranslate(april_label)}</td>
              <td data-key="Generation (MU)">
                {total_generation_from_april}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
            <tr>
              <td data-key="S.No">3</td>
              <td data-key="Description">{maybeTranslate(financial_year)}</td>
              <td data-key="Generation (MU)">
                {total_generation_during_financial_year}&nbsp;
                <strong>{getText("MU", "एमयू")}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* children table */}
      {children.length > 0 &&
        children.map((child) => (
          <div className="table-responsive mb-3" key={child.name}>
            <h3 className="title4">{getTitle(child.name)}</h3>
            <table className="table table-striped custom-table">
              <thead className="thead-dark">
                <tr>
                  <th>{getText("S.No.", "क्र. सं.")}</th>
                  <th>{getText("Description", "विवरण")}</th>
                  <th>{getText("Generation (MU)", "उत्त्पादन (एमयू)")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td data-key="S.No">1</td>
                  <td data-key="Description">
                    {maybeTranslate(child.description)}
                  </td>
                  <td data-key="Generation (MU)">
                    {child.generation_for_the_month}&nbsp;
                    <strong>{getText("MU", "एमयू")}</strong>
                  </td>
                </tr>
                <tr>
                  <td data-key="S.No">2</td>
                  <td data-key="Description">
                    {maybeTranslate(child.april_label)}
                  </td>
                  <td data-key="Generation (MU)">
                    {child.total_generation_from_april}&nbsp;
                    <strong>{getText("MU", "एमयू")}</strong>
                  </td>
                </tr>
                <tr>
                  <td data-key="S.No">3</td>
                  <td data-key="Description">
                    {maybeTranslate(child.financial_year)}
                  </td>
                  <td data-key="Generation (MU)">
                    {/* only  here condition no function */}
                    {parseFloat(
                      child.total_generation_during_financial_year,
                    ) === 0 ? (
                      <strong>{getText("Under R&M", "आर. & एम.")}</strong>
                    ) : (
                      <>
                        {child.total_generation_during_financial_year}&nbsp;
                        <strong>{getText("MU", "एमयू")}</strong>
                      </>
                    )}
                    {/* <strong>{getText("MU", "एमयू")}</strong> */}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
    </>
  );
};

export default StatusOfGeneration;
